import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import Promise from 'bluebird';
import urlParser from 'url-parse';

const HALLMARK = '_stylesheet_link_';
let _stylesheetUrls = Map();

function reconcileHeadWithStylesheets(stylesheetUrls) {
  const head = document.getElementsByTagName('head')[0];
  const links = head.getElementsByTagName('link');
  let queue = stylesheetUrls;

  return new Promise((resolve, reject) => {
    [...links].map((link) => {
      if (link.getAttribute('role') !== HALLMARK) {
        return;
      }

      const url = link.getAttribute('data-url');
      const cacheToken = link.getAttribute('data-cache-token');
      const stillNeeded = queue.has(url);
      const hasNotChanged = queue.get(url, '') === cacheToken;

      if (stillNeeded && hasNotChanged) {
        queue = queue.remove(url);
      } else {
        head.removeChild(link);
      }
    });

    queue.forEach((cacheToken, url) => {
      const link = document.createElement('link');
      const parsedUrl = urlParser(url, true);

      if (cacheToken) {
        parsedUrl.set('query', Object.assign({}, parsedUrl.query, {_: cacheToken}));
      }

      link.setAttribute('data-url', url);
      link.setAttribute('data-cache-token', cacheToken);
      link.setAttribute('href', parsedUrl.toString());
      link.setAttribute('role', HALLMARK);
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');

      head.appendChild(link);

      link.addEventListener('load', (event) => {
        if (event.path && event.path[event.path.length - 1] === document) {
          resolve(url, cacheToken);
        } else {
          resolve(url, cacheToken);
        }
      });
    });
  });
}

function addStylesheetUrl(url, cacheToken) {
  _stylesheetUrls = _stylesheetUrls.set(url, cacheToken);

  return reconcileHeadWithStylesheets(_stylesheetUrls);
}

function removeStylesheetUrl(url) {
  _stylesheetUrls = _stylesheetUrls.delete(url);

  return reconcileHeadWithStylesheets(_stylesheetUrls);
}

export default createReactClass({
  propTypes: {
    href: PropTypes.string.isRequired,
    cacheToken: PropTypes.string,
    onLoaded: PropTypes.func,
    keep: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      cacheToken: '',
      onLoaded: () => undefined,
      keep: false,
    };
  },

  componentDidMount() {
    addStylesheetUrl(this.props.href, this.props.cacheToken)
      .then(() => {
        this.props.onLoaded();
      });
  },

  componentWillUnmount() {
    if (!this.props.keep) {
      removeStylesheetUrl(this.props.href);
    }
  },

  render() {
    return null;
  },
});



// WEBPACK FOOTER //
// ./app/javascript/components/StylesheetLink.js